import Catalog from './Catalog';

export default Catalog;